import { render, staticRenderFns } from "./QuestionnairesList.vue?vue&type=template&id=dc4f2fd0&scoped=true&"
import script from "./QuestionnairesList.vue?vue&type=script&lang=js&"
export * from "./QuestionnairesList.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnairesList.vue?vue&type=style&index=0&id=dc4f2fd0&lang=scss&scoped=true&"
import style1 from "./QuestionnairesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4f2fd0",
  null
  
)

export default component.exports